import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--more"
export default class extends Controller {
  static targets = ["list", "toggle", "item"];

  connect() {
    this.initializeCollapse();
  }

  initializeCollapse() {
    // 二重初期化防止
    if (this.element.dataset.collapseInitialized === "true") return;
    this.element.dataset.collapseInitialized = "true";

    const items = this.itemTargets;
    if (items.length <= 2) {
      // 2件以下ならボタンはいらない
      this.toggleTarget.style.display = "none";
      return;
    }

    // 初期状態：3件目以降は非表示
    this.isOpen = false;
    this.updateDisplay();
  }

  toggle(event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
    this.updateDisplay();
  }

  updateDisplay() {
    const items = this.itemTargets;
    const extras = items.slice(2); // 3件目以降

    extras.forEach((item) => {
      item.style.display = this.isOpen ? "" : "none";
    });

    this.toggleTarget.textContent = this.isOpen ? "閉じる" : "もっとみる";
  }
}
